"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _setPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/setPrototypeOf");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
var version_1 = require("./version");
var Versioning = /*#__PURE__*/function () {
  function Versioning() {
    _classCallCheck(this, Versioning);
  }
  _createClass(Versioning, null, [{
    key: "urlWithVersion",
    /**
     * Return URL with versioning information appended
     */
    value: function urlWithVersion(url) {
      var urlWithVersion = new URL(url);
      urlWithVersion.searchParams.append(Versioning.X_AMZN_VERSION, Versioning.sdkVersion);
      urlWithVersion.searchParams.append(Versioning.X_AMZN_USER_AGENT, Versioning.sdkUserAgentLowResolution);
      return urlWithVersion.toString();
    }
  }, {
    key: "sdkName",
    /**
     * Return string representation of SDK name
     */
    get: function get() {
      return 'amazon-chime-sdk-js';
    }
    /**
     * Return string representation of SDK version
     */
  }, {
    key: "sdkVersion",
    get: function get() {
      return version_1.default.semverString;
    }
    /**
     * Returns the parts of the semver, so major/minor/patch can be extracted individually.
     */
  }, {
    key: "sdkVersionSemVer",
    get: function get() {
      var _a, _b, _c;
      var v = version_1.default.semverString.match(/*#__PURE__*/_wrapRegExp(/^([0-9]+)\.([0-9]+)(?:\.([0-9]+))?/, {
        major: 1,
        minor: 2,
        patch: 3
      }));
      return {
        major: (_a = v === null || v === void 0 ? void 0 : v.groups) === null || _a === void 0 ? void 0 : _a.major,
        minor: (_b = v === null || v === void 0 ? void 0 : v.groups) === null || _b === void 0 ? void 0 : _b.minor,
        patch: (_c = v === null || v === void 0 ? void 0 : v.groups) === null || _c === void 0 ? void 0 : _c.patch
      };
    }
    /**
     * Return the SHA-1 of the Git commit from which this build was created.
     */
  }, {
    key: "buildSHA",
    get: function get() {
      // Skip the leading 'g'.
      return version_1.default.hash.substr(1);
    }
    /**
     * Return low-resolution string representation of SDK user agent (e.g. `chrome-78`)
     */
  }, {
    key: "sdkUserAgentLowResolution",
    get: function get() {
      var browserBehavior = new DefaultBrowserBehavior_1.default();
      return "".concat(browserBehavior.name(), "-").concat(browserBehavior.majorVersion());
    }
  }]);
  return Versioning;
}();
exports.default = Versioning;
Versioning.X_AMZN_VERSION = 'X-Amzn-Version';
Versioning.X_AMZN_USER_AGENT = 'X-Amzn-User-Agent';